var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMenuPawIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    clipPath: "url(#clip0_3071_13154)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.3494 12.0289C21.4274 12.0635 22.3294 11.2175 22.3639 10.1395C22.3984 9.06144 21.5525 8.15953 20.4744 8.12501C19.3964 8.09049 18.4945 8.93642 18.46 10.0145C18.4254 11.0925 19.2714 11.9944 20.3494 12.0289Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.95195 11.4977C5.02999 11.5322 5.9319 10.6863 5.96642 9.60823C6.00095 8.53019 5.15501 7.62828 4.07697 7.59376C2.99892 7.55924 2.09701 8.40517 2.06249 9.48322C2.02797 10.5613 2.87391 11.4632 3.95195 11.4977Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.78789 6.96644C9.86593 7.00096 10.7678 6.15503 10.8024 5.07698C10.8369 3.99894 9.99094 3.09703 8.9129 3.06251C7.83486 3.02799 6.93295 3.87392 6.89843 4.95197C6.86391 6.03001 7.70984 6.93192 8.78789 6.96644Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8143 7.1891C16.8923 7.22362 17.7942 6.37768 17.8287 5.29964C17.8633 4.2216 17.0173 3.31969 15.9393 3.28517C14.8612 3.25064 13.9593 4.09658 13.9248 5.17462C13.8903 6.25266 14.7362 7.15457 15.8143 7.1891Z",
    stroke: "#1A1A1A",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47177 11.3592L9.47217 11.358C9.6594 10.7804 10.0292 10.2793 10.5258 9.9301C11.0224 9.58097 11.6189 9.40254 12.2256 9.42166C12.8322 9.44139 13.4161 9.65762 13.8893 10.0378C14.3626 10.4181 14.6995 10.9418 14.8494 11.5302L14.8496 11.5308C15.222 12.9889 16.156 14.2405 17.4477 15.0126L17.4553 15.0171L17.463 15.0215C17.9941 15.3269 18.3865 15.8257 18.5583 16.4137C18.73 17.0017 18.6678 17.6334 18.3846 18.1766C18.1015 18.7198 17.6192 19.1325 17.0388 19.3284C16.4584 19.5242 15.8247 19.4882 15.2703 19.2277L15.2617 19.2236L15.253 19.2197C13.1416 18.274 10.7429 18.1972 8.57527 19.0059L8.56635 19.0092L8.5575 19.0127C7.98754 19.2372 7.35286 19.2326 6.78616 19C6.21947 18.7674 5.76466 18.3247 5.51681 17.7645C5.26897 17.2043 5.2473 16.57 5.45633 15.9942C5.66535 15.4183 6.08889 14.9456 6.63839 14.6749L6.64618 14.671L6.6539 14.6671C7.99292 13.9795 9.00582 12.7905 9.47177 11.3592Z",
    stroke: "#1A1A1A",
    strokeWidth: 2.1,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3071_13154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuPawIcon);
export default __webpack_public_path__ + "static/media/menu-paw-icon.c6689a45.svg";
export { ForwardRef as ReactComponent };